import * as ActionTypes from './actionTypes';
import { createAction, notIsEmptyList, path } from '../utils';

export function dataUpdate(key, value) {
  return {
    type: ActionTypes.DATA_UPDATE,
    data: {
      key,
      value
    }
  };
}

export function updatePropertyType(value) {
  return {
    type: ActionTypes.PROPERTY_TYPE_UPDATE,
    data: {
      value
    }
  };
}

export function updateNumberOfRooms(value) {
  return {
    type: ActionTypes.NUMBER_OF_ROOMS_UPDATE,
    data: {
      value
    }
  };
}

export function updateEstimatedRevenue(value) {
  return {
    type: ActionTypes.ESTIMATED_REVENUE_UPDATE,
    data: { value }
  };
}

export function updateLocation(value) {
  return {
    type: ActionTypes.LOCATION_UPDATE,
    data: {
      value
    }
  };
}

export function updateLocationObject(value) {
  return {
    type: ActionTypes.LOCATION_OBJECT_UPDATE,
    data: {
      value
    }
  };
}

export function fetchPageDataOnBrowserRouting(page, locale) {
  return {
    fetchConfig: {
      path: '/partnerpage/api/get_page_data',
      method: 'GET',
      queryParams: 'page=' + page + '&country=' + locale,
      start: startFetchPageDataOnBrowserRouting,
      success: successFetchPageDataOnBrowserRouting
    }
  };
}

export function startFetchPageDataOnBrowserRouting() {
  return {
    type: ActionTypes.START_FETCH_PAGE_DATA
  };
}

export function successFetchPageDataOnBrowserRouting(data) {
  return {
    type: ActionTypes.SUCCESS_FETCH_PAGE_DATA,
    data: data
  };
}

export function fetchLocationSearch(query, region, countryIds) {
  console.log('region', region);
  let queryParams = 'query=' + query + '&region=' + region;
  if(notIsEmptyList(countryIds)) queryParams += '&filter_ids=' + countryIds;
  return {
    fetchConfig: {
      path: '/partnerpage/api/search_location',
      method: 'GET',
      queryParams: queryParams,
      start: startLocationSearch,
      success: handleLocationSearchSuccess
    }
  };
}

export function handleLocationSearchSuccess(data) {
  return {
    type: ActionTypes.SUCCESS_FETCH_SEARCH,
    data: data
  };
}

export function startLocationSearch() {
  return {
    type: ActionTypes.START_FETCH_SEARCH
  };
}

export function putPropertyfetch(propertyData) {
  if(propertyData == null)return;
  propertyData['source'] = 'OAM';
  propertyData['sub_source'] = 'OTHER';
  
  return {
    fetchConfig: {
      path: '/partnerpage/api/submit_info',
      method: 'PUT',
      body: JSON.stringify([propertyData]),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startPropertyPut,
      success: successPropertyPut
    }
  };
}

export function putGenOtpPropertyfetch(propertyData) {
  if(propertyData == null)return;
  propertyData['source'] = 'OAM';
  propertyData['sub_source'] = 'OWNER';
  
  return {
    fetchConfig: {
      path: '/partnerpage/api/submit_info',
      method: 'PUT',
      body: JSON.stringify([propertyData]),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startPropertyPut,
      success: successGenOtpPropertyPut
    }
  };
}

export function startPropertyPut() {
  return {
    type: ActionTypes.START_PUT_PROPERTY
  };
}

export function successPropertyPut(data) {
  return {
    type: ActionTypes.SUCCESS_PUT_PROPERTY,
    data: data
  };
}

export function successGenOtpPropertyPut(data) {
  return {
    type: ActionTypes.SUCCESS_PUT_PROPERTY_GEN_OTP,
    data: data
  };
}

export function switchStepsBool(bool) {
  return {
    type: ActionTypes.FLIP_SCROLL_TO_STEPS_BOOL,
    data: bool
  };
}

export function switchProgramsBool(bool) {
  return {
    type: ActionTypes.FLIP_SCROLL_TO_PROGRAMS_BOOL,
    data: bool
  };
}

export function switchSellerBool(bool) {
  return {
    type: ActionTypes.ARE_YOU_A_SELLER_BOOL,
    data: bool
  };
}

export function emptyFormData() {
  return {
    type: ActionTypes.EMPTY_FORM_DATA
  };
}

export function setHeadingHeightForMobile(bool) {
  return {
    type: ActionTypes.MOBILE_HEADER_HEIGHT,
    data: bool
  };
}

export function startGetEarningPotential() {
  return {
    type: ActionTypes.START_GET_EARNING_POTENTIAL
  };
}

export function getEarningPotential(countryId, cityId) {
  return {
    fetchConfig: {
      path: '/partnerpage/api/earning_potential',
      method: 'GET',
      queryParams: 'country_id=' + countryId + '&city_id=' + cityId,
      start: startGetEarningPotential,
      success: successGetEarningPotential,
      error: successGetEarningPotential
    }
  };
}

export function successGetEarningPotential(data) {
  return {
    type: ActionTypes.GET_EARNING_POTENTIAL_SUCCESS,
    data: data
  };
}

export function postSignUp(signUpData) {
  return {
    fetchConfig: {
      path: '/partnerpage/api/otp_service/sign_up',
      method: 'POST',
      body: JSON.stringify(signUpData),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startSignUp,
      success: successSignUp,
      error: errorSignUp
    }
  };
}

export function startSignUp() {
  return {
    type: ActionTypes.START_SIGN_UP
  };
}

export function successSignUp(data) {
  return {
    type: ActionTypes.SUCCESS_SIGN_UP,
    data: data
  };
}

export function errorSignUp(error) {
  let message = error;
  if (error.message) message = error.message;
  return {
    type: ActionTypes.ERROR_SIGN_UP,
    errorMessage: message
  };
}

export function postLogin(loginData) {
  return {
    fetchConfig: {
      path: '/partnerpage/api/auth_service/sign_in',
      method: 'POST',
      body: JSON.stringify(loginData),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startLogin,
      success: successLogin,
      error: errorLogin
    }
  };
}

export function startLogin() {
  return {
    type: ActionTypes.START_LOGIN
  };
}

export function successLogin(data) {
  return {
    type: ActionTypes.SUCCESS_LOGIN,
    data: data
  };
}

export function errorLogin(error) {
  let message = error;
  if (error.message) message = error.message;
  return {
    type: ActionTypes.ERROR_LOGIN,
    errorMessage: message
  };
}

export function postOtp(phone, phone_code, iso_code) {
  let otpData = {
    phone: phone,
    country_code: phone_code,
  };
  
  return {
    fetchConfig: {
      path: '/partnerpage/api/otp_service/generate_otp',
      method: 'POST',
      body: JSON.stringify(otpData),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startOtp,
      success: successOtp,
      error: errorOtp
    }
  };
}

export function startOtp() {
  return {
    type: ActionTypes.START_OTP
  };
}

export function successOtp(data) {
  return {
    type: ActionTypes.SUCCESS_OTP,
    data: data
  };
}

export function errorOtp(error) {
  let message = error;
  if (path(error,'message')) message = error.message;
  return {
    type: ActionTypes.ERROR_OTP,
    errorMessage: message
  };
}

export function carouselModeUpdate(data) {
  return {
    type: ActionTypes.CAROUSEL_MODE_UPDATE,
    data: data
  };
}
export function postLoginOtp(loginData) {
  return {
    fetchConfig: {
      path: '/partnerpage/api/auth_service/sign_in_otp',
      method: 'POST',
      body: JSON.stringify(loginData),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startLogin,
      success: successLogin,
      error: errorLogin
    }
  };
}

export function postOtpLogin(phone, phone_code, iso_code) {
  let otpData = {
    phone: phone,
    country_code: phone_code,
    country_iso_code: iso_code
  };
  
  return {
    fetchConfig: {
      path: '/partnerpage/api/otp_service/generate_login_otp',
      method: 'POST',
      body: JSON.stringify(otpData),
      headers: {
        'Content-Type': 'application/json'
      },
      start: startOtp,
      success: successOtp,
      error: errorOtp
    }
  };
}

export const updateGlobalData = createAction(ActionTypes.UPDATE_GLOBAL_DATA);
